import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import {
  MerchantEmailCampaignStatus,
  MerchantEmailFrequency,
  MerchantEmailRecipientType,
  MerchantEmailTrigger,
} from "./merchant-email-trigger";

const MerchantEmailConfigInputSchema_ = z.object({
  name: z.string(),
  trigger: createEnum(MerchantEmailTrigger),
  subject: z.string(),
  htmlTemplate: z.string(),
  recipients: z.array(createEnum(MerchantEmailRecipientType)),
  frequency: createEnum(MerchantEmailFrequency),
  cooldownHours: z.number().nullish(),
  excludedTeamIds: z.array(z.string()),
});

export const MerchantEmailConfigInputSchema: z.ZodType<MerchantEmailConfigInput> =
  MerchantEmailConfigInputSchema_;

export interface MerchantEmailConfigInput
  extends z.infer<typeof MerchantEmailConfigInputSchema_> {}

const MerchantEmailConfigSchema_ = MerchantEmailConfigInputSchema_.extend({
  id: z.string(),
  status: createEnum(MerchantEmailCampaignStatus),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const MerchantEmailConfigSchema: z.ZodType<MerchantEmailConfig> =
  MerchantEmailConfigSchema_;

export interface MerchantEmailConfig
  extends z.infer<typeof MerchantEmailConfigSchema_> {}

const MerchantEmailCampaignStatsSchema_ = z.object({
  campaignId: z.string(),
  sendCount: z.number(),
});

export const MerchantEmailCampaignStatsSchema: z.ZodType<MerchantEmailCampaignStats> =
  MerchantEmailCampaignStatsSchema_;

export interface MerchantEmailCampaignStats
  extends z.infer<typeof MerchantEmailCampaignStatsSchema_> {}

const MerchantEmailSendLogSchema_ = z.object({
  id: z.string(),
  campaignId: z.string(),
  trigger: createEnum(MerchantEmailTrigger),
  teamId: z.string(),
  sentAt: z.date(),
});

export const MerchantEmailSendLogSchema: z.ZodType<MerchantEmailSendLog> =
  MerchantEmailSendLogSchema_;

export interface MerchantEmailSendLog
  extends z.infer<typeof MerchantEmailSendLogSchema_> {}
